module.exports = __webpack_public_path__ + "img/vitamins.621de68d.png";